module.exports = __webpack_public_path__ + "img/filter.82fdfd6c.svg";